import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

export const blogApi = {
  list: () => api.get("/blog/posts"),
  get: (slug) => api.get(`/blog/posts/${slug}`),
};

export const adminBlogApi = {
  list: (token) => api.get("/admin/blog/posts", { headers: { Authorization: `Bearer ${token}` } }),
  create: (post, token) =>
    api.post("/admin/blog/posts", post, { headers: { Authorization: `Bearer ${token}` } }),
  update: (id, post, token) =>
    api.put(`/admin/blog/posts/${id}`, post, { headers: { Authorization: `Bearer ${token}` } }),
  remove: (id, token) =>
    api.delete(`/admin/blog/posts/${id}`, { headers: { Authorization: `Bearer ${token}` } }),
};

export default api;
